import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Container,
  Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import RegisterForm from '../../components/Auth/RegisterForm';
// import SocialLoginButtons from '../../components/Auth/SocialLoginButtons'; // フェーズ1では非表示

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleLogin = () => {
    navigate('/auth/login');
  };

  // フェーズ1では非表示 - 将来フェーズで実装予定
  // const handleGoogleRegister = () => {
  //   // TODO: Implement Google OAuth registration
  //   console.log('Google register clicked');
  // };

  // const handleMicrosoftRegister = () => {
  //   // TODO: Implement Microsoft OAuth registration
  //   console.log('Microsoft register clicked');
  // };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container 
        maxWidth={false}
        sx={{
          maxWidth: { xs: '100%', sm: '520px', md: '580px', lg: '620px' },
          width: '100%',
        }}
      >
        <Card
          elevation={8}
          sx={{
            borderRadius: { xs: 2, sm: 3, md: 4 },
            overflow: 'hidden',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <CardContent sx={{ p: { xs: 3, sm: 4, md: 5, lg: 6 } }}>
            {/* Header */}
            <Box sx={{ textAlign: 'center', mb: { xs: 3, sm: 4, md: 5 } }}>
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontSize: 'clamp(1.3rem, 6vw, 2rem) !important',
                  letterSpacing: '-0.01em',
                  whiteSpace: 'nowrap',
                }}
              >
                ガクフドキャリア
              </Typography>
              <Typography 
                variant="h6" 
                color="text.secondary"
                sx={{ 
                  fontSize: 'clamp(1rem, 4vw, 1.3rem) !important',
                  letterSpacing: '-0.01em',
                  whiteSpace: 'nowrap',
                }}
              >
                新規登録
              </Typography>
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ 
                  mt: 1,
                  fontSize: { xs: '0.875rem', sm: '0.9rem', md: '1rem' },
                  maxWidth: { xs: '100%', sm: '450px' },
                  mx: 'auto',
                }}
              >
                アカウントを作成してガクフドキャリアを始めましょう
              </Typography>
            </Box>

            {/* Registration Form */}
            <RegisterForm onLogin={handleLogin} />

            {/* Social Login Buttons - フェーズ1では非表示 */}
            {/* <SocialLoginButtons
              onGoogleLogin={handleGoogleRegister}
              onMicrosoftLogin={handleMicrosoftRegister}
              variant="register"
            /> */}
          </CardContent>
        </Card>

        {/* Footer */}
        <Box sx={{ textAlign: 'center', mt: { xs: 2, sm: 3, md: 4 } }}>
          <Typography 
            variant="body2" 
            color="white" 
            sx={{ 
              opacity: 0.8,
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              mb: 1,
            }}
          >
            © {currentYear} ガクフドキャリア. All rights reserved.
          </Typography>
          <Link 
            href="/privacy-policy"
            color="inherit"
            sx={{
              color: 'white',
              opacity: 0.8,
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
                opacity: 1,
              },
            }}
          >
            プライバシーポリシー
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default RegisterPage;